import { memo } from 'react';
import { Html } from '@react-three/drei';
import { useContextBridge } from 'its-fine';
import style from './EclipseContent.style';
import animation from './eclipseContent.animation.json';
import { Visible, parallax } from '@immutabl3/alchemy';

const Content = memo(() => {
  return (
    <div css={ style }>
      <div>
        <p className="strong">
          <parallax.span beaker="chapter1" animation={ animation }>
            Have an edge
          </parallax.span>
        </p>
      </div>
    </div>
  );
});

const EclipseContent = memo(function() {
  const Bridge = useContextBridge();
  return (
    <Html
      wrapperClass="no-interact"
      transform
      sprite
    >
      <Bridge>
        <Content />
      </Bridge>
    </Html>
  );
});

export default function EclipseContentContainer() {
  return (
    <Visible beaker="chapter1" animation={ animation }>
      <EclipseContent />
    </Visible>
  );
};
